import { render, staticRenderFns } from "./ServerViewerChannel.vue?vue&type=template&id=7ab22cfe&scoped=true"
import script from "./ServerViewerChannel.vue?vue&type=script&lang=js"
export * from "./ServerViewerChannel.vue?vue&type=script&lang=js"
import style0 from "./ServerViewerChannel.vue?vue&type=style&index=0&id=7ab22cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab22cfe",
  null
  
)

export default component.exports